<template>
    <div>
        <div style="margin-bottom: 20px;font-size: 13px;color:#666;">请对 "{{kuinfo.name}}" 项目进行制作设置</div>
        
        <div style="display: flex;align-items: center;justify-content: space-between;">
            <div>制作数量</div>
            <el-input-number v-model="make_num" :min="1" :max="10" label="描述文字" size="small" style="margin-left: 15px;">
            </el-input-number>
        </div>
        <div style="margin: 30px 0px 0px 0px;color: #888;font-size: 13px;">
            其他设置（请了解后再开启）
        </div>
        <div style="display: flex;align-items: center;margin-top: 20px;justify-content: space-between;">
            <div style="width: 150px;">
                固定判断时间
                <div style="font-size: 12px;color:#999">片段长可选</div>
            </div>
            <div v-if="gdtime_open">

                <el-select v-model="gdsj_time" placeholder="请选择" style="width: 70px;" size="small">
                    <el-option v-for="item in all_time" :key="item" :label="item" :value="item">
                    </el-option>
                </el-select> 秒
            </div>

            <el-switch v-model="gdtime_open" active-color="#13ce66" style="margin-right: 10px;">
            </el-switch>
        </div>
        <div style="display: flex;align-items: center;margin-top: 20px;justify-content: space-between;">
            <div style="width: 150px;">
                片段掐头去尾
                <div style="font-size: 12px;color:#999">建议原创拍摄视频</div>
            </div>
            <div v-if="qtqw_open">
                <el-select v-model="qtqw_time" placeholder="请选择" style="width: 70px;" size="small">
                    <el-option v-for="item in all_time" :key="item" :label="item" :value="item">
                    </el-option>
                </el-select> 秒
            </div>
            <el-switch v-model="qtqw_open" active-color="#13ce66" style="margin-right: 10px;">
            </el-switch>
        </div>
        <div style="display: flex;align-items: center;margin-top: 20px;justify-content: space-between;">
            <div style="width: 150px;">
                随机视频
                <div style="font-size: 12px;color:#999">可能会有重复画面</div>
            </div>

            <el-switch v-model="sjpd_open" active-color="#13ce66" style="margin-right: 10px;">
            </el-switch>
        </div>
        <div style="display: flex;align-items: center;margin-top: 20px;justify-content: space-between;">
            <div style="width: 150px;">
                随机镜像
                <div style="font-size: 12px;color:#999">对画面片段随机镜像</div>
            </div>

            <el-switch v-model="sjjx_open" active-color="#13ce66" style="margin-right: 10px;">
            </el-switch>
        </div>
        <div style="display:flex;justify-content: end;margin-top: 30px;">
            <el-button type="primary" size="medium" @click="ks">开始制作</el-button>
        </div>

    </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）

export default {
    name: '',
    components: {

    },
    props: ["kuinfo"],
    // 定义属性
    data() {
        return {
            make_num: 1,
            gdtime_open: false,
            qtqw_open: false,
            sjpd_open:false,
            sjjx_open:false,
            qtqw_time: '0.1',
            gdsj_time: '0.1',
            all_time: ['0.1', '0.2', '0.4', '0.6', '0.8', '1.0', '1.2', '1.4', '1.6'
            , '1.8', '2.0', '2.2', '2.4', '2.6', '2.8', '3.0']

        }
    },
    // 计算属性，会监听依赖属性值随之变化
    computed: {},
    // 监控data中的数据变化
    watch: {},
    // 方法集合
    methods: {
        ks(){

            const loading = this.$loading(this.$loadinginfo);
            console.log(this.kuinfo)
            var gdtime=0
            var qtqw=0
            if(this.gdtime_open){
                gdtime=this.gdsj_time
            }
            if(this.qtqw_open){
                qtqw=this.qtqw_time
            }
            var data = {
                'kuid':this.kuinfo.id,
                'kuname':this.kuinfo.name,
                'num':this.make_num,
                'gdtime':gdtime,
                'qtqw':qtqw,
                'hmsj':this.sjpd_open?1:0,
                'hmjx':this.sjjx_open?1:0
            }
            this.$ajax.post('/qhy/spk/zzsp', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(res => {
                // console.log(res.data)
                if (res.data.status == 200) {
                    console.log(res.data)
                    this.make_num=1
                    this.gdtime_open=false
                    this.qtqw_open=false
                    this.sjjx_open=false
                    this.sjpd_open=false
                    this.$msg.success(res.data.msg)
                    // this.$emit('make_video_wc')
                    this.$parent.$parent.make_video_wc()
                } else {
                    this.$msg.error(res.data.msg)
                }
                loading.close();
            })
        }
    },
    // 生命周期 - 创建完成（可以访问当前this实例）
    created() {
    
    },
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
        
    },
    beforeCreate() { }, // 生命周期 - 创建之前
    beforeMount() { }, // 生命周期 - 挂载之前
    beforeUpdate() { }, // 生命周期 - 更新之前
    updated() { }, // 生命周期 - 更新之后
    beforeDestroy() { }, // 生命周期 - 销毁之前
    destroyed() { }, // 生命周期 - 销毁完成
    activated() { }, // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/User/Ku_makevideo.vue


// WEBPACK FOOTER //
// src/components/User/Ku_makevideo.vue